export default __webpack_public_path__ + "static/media/Benefits new.e44619ac.jpg";